import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-content {
    margin: 0;
    padding: 10px 0 0 0;
  }
`;

export const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
`;

const FooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
`;

const CancelButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.dark1};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginButton = styled.div`
  cursor: pointer;
  color: ${(props) => props.theme.blackGradient};
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.golden};
  border-radius: 0 0 8px 0;
`;

const LoginAlert = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const open = useSelector((state) => state.auth.openLoginAlert);

  const goToLogin = () => {
    handleClose();
    navigate(`/${PUBLIC_ROUTE.LOGIN}`);
  };

  const handleClose = () => dispatch(setOpenLoginAlert(false));

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      footer={
        <FooterContainer>
          <CancelButton onClick={handleClose}>
            {t("common.cancel")}
          </CancelButton>
          <LoginButton onClick={goToLogin}>{t("auth.login")}</LoginButton>
        </FooterContainer>
      }
      width={300}
      open={open}
    >
      <div style={{ textAlign: "center" }}>
        <ModalTitle>{t("auth.unauthorized")}</ModalTitle>
        <ModalText>{t("auth.loginFirst")}</ModalText>
      </div>
    </Modal>
  );
};

export default LoginAlert;
